/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-16 13:45:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/TabBarStyle/index.tsx
 */

import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSubmitStamp,
  getTabBarStyle,
  onCollapseOpen,
  onErrorChange,
  onTabBarStyleChange,
  onTabBarStyleReset,
} from '../slice';

const suffix = 'salesChannelContentEditorAppearance';
const idSet = {
  buyNowButtonBackgroundColour: suffix + 'buyNowButtonBackgroundColour',
  buyNowButtonTextColour: suffix + 'buyNowButtonTextColour',
  addToCartBackgroundColour: suffix + 'addToCartBackgroundColour',
  addToCartTextColour: suffix + 'addToCartTextColour',
  quantityButtonBackgroundColour: suffix + 'quantityButtonBackgroundColour',
  quantityButtonTextColour: suffix + 'quantityButtonTextColour',
  homePageIconBackgroundColour: suffix + 'homePageIconBackgroundColour',
  homePageIconColour: suffix + 'homePageIconColour',
  iconsButtonTextColour: suffix + 'iconsButtonTextColour',
  iconsButtonBackground: suffix + 'iconsButtonBackground',
  soldOutButtonBackground: suffix + 'soldOutButtonBackground',
  soldOutButtonTextColour: suffix + 'soldOutButtonTextColour',
  remindMeButtonBackground: suffix + 'remindMeButtonBackground',
  remindMeButtonTextColor: suffix + 'remindMeButtonTextColor',
};
const TabBarStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, isResponsive } = props;
  const { iconText, addToCart, buyNow, soldOut, remindMe } = data || {};

  const _d = useDispatch();
  const handleIconText = (key, data, soldOut) => {
    _d(
      onTabBarStyleChange({
        key: key,
        data,
        soldOut: soldOut,
      }),
    );
  };

  return (
    <React.Fragment>
      {!isResponsive && (
        <Section bottomBorder>
          <ItemWrapper
            id={idSet.iconsButtonBackground}
            title={getI18n(
              'salesChannelContent.index.icon&TextBackgroundColour',
            )}>
            <ColorPicker
              id={idSet.iconsButtonBackground}
              onChange={(color) =>
                handleIconText('iconText', { backgroundColor: color }, false)
              }
              multi
              color={iconText.backgroundColor}
            />
          </ItemWrapper>
          <ItemWrapper
            id={idSet.iconsButtonTextColour}
            title={getI18n('salesChannelContent.index.textIconColour')}>
            <ColorPicker
              id={idSet.iconsButtonTextColour}
              onChange={(color) =>
                handleIconText('iconText', { textColor: color }, false)
              }
              multi
              color={iconText.textColor}
            />
          </ItemWrapper>
        </Section>
      )}

      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n('general.status.active')}></ItemWrapper>
        <ItemWrapper
          id={idSet.addToCartBackgroundColour}
          title={`“${getI18n('salesChannelContent.index.addtoCart')}” ${getI18n(
            'general.buttonBackgroundColour',
          )}`}>
          <ColorPicker
            onChange={(color) =>
              handleIconText('addToCart', { backgroundColor: color }, false)
            }
            multi
            id={idSet.addToCartBackgroundColour}
            color={addToCart.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.addToCartTextColour}
          title={`“${getI18n('salesChannelContent.index.addtoCart')}” ${getI18n(
            'general.buttonTextColour',
          )}`}>
          <ColorPicker
            onChange={(color) =>
              handleIconText('addToCart', { textColor: color }, false)
            }
            multi
            color={addToCart.textColor}
            id={idSet.addToCartTextColour}
          />
        </ItemWrapper>
        {!isResponsive && (
          <React.Fragment>
            <ItemWrapper
              id={idSet.buyNowButtonBackgroundColour}
              title={`“${getI18n(
                'salesChannelContent.index.buyNow',
              )}” ${getI18n('general.buttonBackgroundColour')}`}>
              <ColorPicker
                id={idSet.buyNowButtonBackgroundColour}
                onChange={(color) =>
                  handleIconText('buyNow', { backgroundColor: color }, false)
                }
                multi
                color={buyNow.backgroundColor}
              />
            </ItemWrapper>
            <ItemWrapper
              id={idSet.buyNowButtonTextColour}
              title={`“${getI18n(
                'salesChannelContent.index.buyNow',
              )}” ${getI18n('general.buttonTextColour')}`}>
              <ColorPicker
                onChange={(color) =>
                  handleIconText('buyNow', { textColor: color }, false)
                }
                multi
                id={idSet.buyNowButtonTextColour}
                color={buyNow.textColor}
              />
            </ItemWrapper>
          </React.Fragment>
        )}
      </Section>
      <Section>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n(
            'salesChannelContent.index.soldOut',
          )}></ItemWrapper>
        <ItemWrapper
          id={idSet.soldOutButtonBackground}
          title={`“${getI18n('salesChannelContent.index.soldOut')}” ${getI18n(
            'general.buttonBackgroundColour',
          )}`}>
          <ColorPicker
            onChange={(color) =>
              handleIconText('soldOut', { backgroundColor: color }, true)
            }
            multi
            id={idSet.soldOutButtonBackground}
            color={soldOut.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.soldOutButtonTextColour}
          title={`“${getI18n('salesChannelContent.index.soldOut')}” ${getI18n(
            'general.buttonTextColour',
          )}`}>
          <ColorPicker
            onChange={(color) =>
              handleIconText('soldOut', { textColor: color }, true)
            }
            multi
            id={idSet.soldOutButtonTextColour}
            color={soldOut.textColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.remindMeButtonBackground}
          title={`“${getI18n('salesChannelContent.index.remindMe')}” ${getI18n(
            'general.buttonBackgroundColour',
          )}`}>
          <ColorPicker
            onChange={(color) =>
              handleIconText('remindMe', { backgroundColor: color }, true)
            }
            multi
            id={idSet.remindMeButtonBackground}
            color={remindMe.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.remindMeButtonTextColor}
          title={`“${getI18n('salesChannelContent.index.remindMe')}” ${getI18n(
            'general.buttonTextColour',
          )}`}>
          <ColorPicker
            onChange={(color) =>
              handleIconText('remindMe', { textColor: color }, true)
            }
            multi
            id={idSet.remindMeButtonTextColor}
            color={remindMe.textColor}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(TabBarStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.productDetailsPageTabBarStyle,
  getContent: getTabBarStyle,
  title: getI18nFromGeneral('general.hOCTitle.productDetailsPageTabBarStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onTabBarStyleReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
